<template>
  <div>
    <div class="text-center py-3">
      <h5 class="mb-0 fw-700">
        <slot />

        <small class="text-muted mb-0">{{ $t(label) }}</small>
      </h5>

      <slot name="outerText" />
    </div>
  </div>
</template>

<script>
// @vuese
// Element szczegółów
// @group Details
export default {
  props: {
    // Label szczegółu
    label: {
      type: String,
      required: false
    }
  }
};
</script>
